// extracted by mini-css-extract-plugin
export default {"OptionContainer":"option_OptionContainer__0UP5B","IconContainer":"option_IconContainer__si91x","TextContainer":"option_TextContainer__DXAap","SubTitle":"option_SubTitle__C0VU9"};